import { GenIcon } from '../helpers/IconBase.es.js';

const MobiphoneOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-vm9sv50fd", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.75 4.63636C6.75 4.08407 7.14588 3.75 7.5 3.75H16.5C16.8541 3.75 17.25 4.08407 17.25 4.63636V19.3636C17.25 19.9159 16.8541 20.25 16.5 20.25H7.5C7.14588 20.25 6.75 19.9159 6.75 19.3636V4.63636ZM7.5 2.25C6.19726 2.25 5.25 3.38118 5.25 4.63636V19.3636C5.25 20.6188 6.19726 21.75 7.5 21.75H16.5C17.8027 21.75 18.75 20.6188 18.75 19.3636V4.63636C18.75 3.38118 17.8027 2.25 16.5 2.25H7.5ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.75 4.63636C6.75 4.08407 7.14588 3.75 7.5 3.75H16.5C16.8541 3.75 17.25 4.08407 17.25 4.63636V19.3636C17.25 19.9159 16.8541 20.25 16.5 20.25H7.5C7.14588 20.25 6.75 19.9159 6.75 19.3636V4.63636ZM7.5 2.25C6.19726 2.25 5.25 3.38118 5.25 4.63636V19.3636C5.25 20.6188 6.19726 21.75 7.5 21.75H16.5C17.8027 21.75 18.75 20.6188 18.75 19.3636V4.63636C18.75 3.38118 17.8027 2.25 16.5 2.25H7.5ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.5 2.75C6.53515 2.75 5.75 3.59211 5.75 4.63636H7.75C7.75 4.60883 7.75594 4.63359 7.72123 4.67056C7.6983 4.69499 7.63079 4.75 7.5 4.75V2.75ZM16.5 2.75H7.5V4.75H16.5V2.75ZM18.25 4.63636C18.25 3.59211 17.4648 2.75 16.5 2.75V4.75C16.3692 4.75 16.3017 4.69499 16.2788 4.67056C16.2441 4.63359 16.25 4.60883 16.25 4.63636H18.25ZM18.25 19.3636V4.63636H16.25V19.3636H18.25ZM16.5 21.25C17.4648 21.25 18.25 20.4079 18.25 19.3636H16.25C16.25 19.3912 16.2441 19.3664 16.2788 19.3294C16.3017 19.305 16.3692 19.25 16.5 19.25V21.25ZM7.5 21.25H16.5V19.25H7.5V21.25ZM5.75 19.3636C5.75 20.4079 6.53515 21.25 7.5 21.25V19.25C7.63079 19.25 7.6983 19.305 7.72123 19.3294C7.75594 19.3664 7.75 19.3912 7.75 19.3636H5.75ZM5.75 4.63636V19.3636H7.75V4.63636H5.75ZM6.25 4.63636C6.25 3.84148 6.83724 3.25 7.5 3.25V1.25C5.55729 1.25 4.25 2.92087 4.25 4.63636H6.25ZM6.25 19.3636V4.63636H4.25V19.3636H6.25ZM7.5 20.75C6.83724 20.75 6.25 20.1585 6.25 19.3636H4.25C4.25 21.0791 5.55728 22.75 7.5 22.75V20.75ZM16.5 20.75H7.5V22.75H16.5V20.75ZM17.75 19.3636C17.75 20.1585 17.1628 20.75 16.5 20.75V22.75C18.4427 22.75 19.75 21.0791 19.75 19.3636H17.75ZM17.75 4.63636V19.3636H19.75V4.63636H17.75ZM16.5 3.25C17.1628 3.25 17.75 3.84148 17.75 4.63636H19.75C19.75 2.92087 18.4427 1.25 16.5 1.25V3.25ZM7.5 3.25H16.5V1.25H7.5V3.25ZM12 20C13.1046 20 14 19.1046 14 18H12V20ZM10 18C10 19.1046 10.8954 20 12 20V18H10ZM12 16C10.8954 16 10 16.8954 10 18H12V16ZM14 18C14 16.8954 13.1046 16 12 16V18H14Z",
          fill: "#82869E",
          mask: "url(#icon-vm9sv50fd)"
        }
      }
    ]
  })(props);
};

export { MobiphoneOutlined };
